import { cloneDeep } from 'lodash';
import { INTEGRATION_SETTING_TYPE } from '../../../../common/constants/IntegrationConstants';
import {
  CONFIG_STATUS_LEVEL,
  CONFIG_TYPES,
  CRM_TOGGLE_TEMPLATE,
  SIDE_NAV_BAR_OPTIONS,
} from '../../../../common/constants/integrationConstants/crmConstants';
import {
  getIntegrationContextValueObj,
  isToggleEnable,
} from '../../../../common/util/crmIntegrationUtils/crmUtils';
import {
  cancelAdditionalDeduplicationStatus,
  changeAdditionalDeduplicationStatus,
  clearUnsavedChanges,
  fetchAdditionalDeduplicationStatus,
  saveAdditionalDeduplicationStatus,
} from '../../../routines/integrations/crmRoutines';

const initialState = {
  [CONFIG_TYPES.ADDITIONAL_DEDUPLICATION]: {
    organization: CRM_TOGGLE_TEMPLATE,
    account: CRM_TOGGLE_TEMPLATE,
  },
  persistedStateAdditionalDeduplication: null,
  loading: false,
  error: null,
  hasUnSavedConfig: false,
};

const crmAdditionalDeduplicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case clearUnsavedChanges.TRIGGER: {
      const { sideNavBarTab } = action.payload;

      const { hasUnSavedConfig } = { ...state };
      if (
        sideNavBarTab === SIDE_NAV_BAR_OPTIONS.DEDUPLICATION &&
        hasUnSavedConfig
      ) {
        const previousAdditionalDeduplicationStatus = cloneDeep(
          state.persistedStateAdditionalDeduplication
        );
        return {
          ...state,
          [CONFIG_TYPES.ADDITIONAL_DEDUPLICATION]:
            previousAdditionalDeduplicationStatus,
          hasUnSavedConfig: false,
        };
      }
      return {
        ...state,
      };
    }
    case saveAdditionalDeduplicationStatus.TRIGGER:
      return {
        ...state,
      };
    case saveAdditionalDeduplicationStatus.SUCCESS: {
      const { enable, entityLevel } = action.payload;

      const newDeduplicationState = {
        ...state[CONFIG_TYPES.ADDITIONAL_DEDUPLICATION],
        [entityLevel]: {
          ...state[CONFIG_TYPES.ADDITIONAL_DEDUPLICATION][entityLevel],
          enable,
          status: CONFIG_STATUS_LEVEL.SAVED,
        },
      };

      return {
        ...state,
        [CONFIG_TYPES.ADDITIONAL_DEDUPLICATION]: newDeduplicationState,
        persistedStateAdditionalDeduplication: newDeduplicationState,
        loading: false,
        error: false,
        hasUnSavedConfig: false,
      };
    }
    case changeAdditionalDeduplicationStatus.TRIGGER: {
      const { enable, entityLevel } = action.payload;
      return {
        ...state,
        [CONFIG_TYPES.ADDITIONAL_DEDUPLICATION]: {
          ...state[CONFIG_TYPES.ADDITIONAL_DEDUPLICATION],
          [entityLevel]: {
            ...state[CONFIG_TYPES.ADDITIONAL_DEDUPLICATION][entityLevel],
            enable,
            status: CONFIG_STATUS_LEVEL.COMPLETED,
          },
        },
        hasUnSavedConfig: true,
      };
    }
    case cancelAdditionalDeduplicationStatus.TRIGGER: {
      const previousAdditionalDeduplicationStatus = cloneDeep(
        state.persistedStateAdditionalDeduplication
      );
      return {
        ...state,
        [CONFIG_TYPES.ADDITIONAL_DEDUPLICATION]:
          previousAdditionalDeduplicationStatus,
        hasUnSavedConfig: false,
      };
    }
    case fetchAdditionalDeduplicationStatus.TRIGGER:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case fetchAdditionalDeduplicationStatus.SUCCESS: {
      const data = action.payload || {};
      const additionalDeduplicationEnable = isToggleEnable(
        data,
        INTEGRATION_SETTING_TYPE.ADDITIONAL_DEDUPLICATION
      );

      const newDeduplicationUpdateState = {
        organization: getIntegrationContextValueObj(
          additionalDeduplicationEnable?.organizationNaNa || 0
        ),
        account: getIntegrationContextValueObj(
          additionalDeduplicationEnable?.accountNaNa || 0
        ),
      };

      return {
        ...state,
        [CONFIG_TYPES.ADDITIONAL_DEDUPLICATION]: newDeduplicationUpdateState,
        persistedStateAdditionalDeduplication: newDeduplicationUpdateState,
        loading: false,
        error: false,
        hasUnSavedConfig: false,
      };
    }
    default:
      return state;
  }
};
export default crmAdditionalDeduplicationReducer;
